import { CuriosityNamespaceType, useCuriosityTranslationLoader } from '@procureai/curiosity-ui-mui';
import { useEffect } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';

export const usePrefillDeliveryLocation = (
  form: UseFormReturn<any>, // Using the specific types of complex and normal form results in type errors
) => {
  const organizationId = useWatch({ control: form.control, name: 'organizationId' });
  const { load } = useCuriosityTranslationLoader();

  useEffect(() => {
    const fetchOrganization = async () => {
      if (organizationId) {
        const org = await load(CuriosityNamespaceType.ORGANIZATION, organizationId);

        if (org?.entity?.location?.id) {
          form.setValue('deliveryLocationId', org?.entity?.location?.id);
        }
      }
    };
    fetchOrganization();
  }, [form, load, organizationId]);
};
